import { observer } from 'mobx-react-lite';

import { Button } from '@/components/ui/Button';
import { XStack, YStack } from '@/components/ui/layout/layout';
import {
  useHiddenMeetingCircles,
  useUnhideMeetingCircle,
} from '@/features/meetings/meetings.hooks';

import { SettingsSection } from '../settings-section';

export const HiddenCirclesOption = observer(() => {
  const hiddenCircles = useHiddenMeetingCircles();
  const unhideMeetingCircle = useUnhideMeetingCircle();
  const hasHiddenCircles = hiddenCircles.length > 0;

  return (
    <SettingsSection.Item
      direction="vertical"
      searchId="meetings.hidden-circles"
    >
      <SettingsSection.ItemHeader>
        <SettingsSection.ItemLabel>Hidden circles</SettingsSection.ItemLabel>
        <SettingsSection.ItemDescription>
          {hasHiddenCircles
            ? 'Circles you hid from the Meetings sidebar. Their meetings were never deleted.'
            : 'Right-click a circle in the Meetings sidebar to hide it.'}
        </SettingsSection.ItemDescription>
      </SettingsSection.ItemHeader>
      {hasHiddenCircles && (
        <YStack className="mt-2 w-full gap-1 rounded-lg border border-border bg-surface p-2">
          {hiddenCircles.map(({ key, name }) => (
            <XStack
              key={key}
              className="items-center justify-between gap-2 px-2 py-1"
            >
              <span className="min-w-0 truncate text-sm">{name}</span>
              <Button
                variant="ghost"
                size="xs"
                onClick={() => unhideMeetingCircle(key)}
              >
                Unhide
              </Button>
            </XStack>
          ))}
        </YStack>
      )}
    </SettingsSection.Item>
  );
});
